// SPEC: https://www.figma.com/design/0lpb5QJNnDkKpThyJGfXqu/%E2%9D%96-Flipster-Design-System?node-id=585-32092&m=dev
export const breakpoints = {
  tablet: '768px',
  smallDesktop: '1280px',
  largeDesktop: '1920px',
};
